import type { ExtendedFileMetadata } from '@/modules/Editor/metadata'
import type { IPoint } from '@/modules/Editor/point'
import type { VoxelRasterDimensions } from '@/modules/Editor/models/raster/VoxelRaster'

export const getXYVoxelScaling = (
  metadata: ExtendedFileMetadata,
  voxelRasterDimensions: VoxelRasterDimensions,
): IPoint | undefined => {
  const { medical: medicalMetadata } = metadata

  if (!medicalMetadata || !voxelRasterDimensions) {
    return
  }

  const { width, height } = metadata

  return { x: width / voxelRasterDimensions.width, y: height / voxelRasterDimensions.height }
}
